import { UUID } from "io-ts-types";
import { useState } from "react";

import { Button, ButtonTargetKind } from "src/components/Button";
import { Modal, ModalProps } from "src/components/Modal";
// import { deleteFundraiser } from "src/pages/Fundraiser/EditForm/actions";
import { ButtonRole, ButtonSize } from "src/styles/button";
import { verticalStackCss, horizontalStackCss } from "src/theme/spacing";

interface EndConfirmationModalProps extends Pick<ModalProps, "isOpen"> {
  isOpen: boolean;
  onConfirm: () => void;
  onReject: () => void;
  nonprofitName: string;
  fundraiserId: UUID;
  nonprofitId: UUID;
  isActive: boolean;
}

export const EndConfirmationModal = (props: EndConfirmationModalProps) => {
  const [submitting, setSubmitting] = useState(false);

  const onEndFundraiser = () => {
    setSubmitting(true);
    props.onConfirm();
    setSubmitting(false);
  };

  return (
    <Modal
      isOpen={props.isOpen}
      onRequestClose={props.onReject}
      headerText={
        props.isActive ? "End your fundraiser?" : "Resume your fundraiser?"
      }
      showHeader
      onAfterClose={props.onReject}
    >
      <div css={[verticalStackCss.s, { maxWidth: 440 }]}>
        <p>
          {props.isActive
            ? "Donors will no longer be able to contribute, but the fundraiser will still be visible."
            : "After resuming, your fundraiser will be active and able to accept donations again."}
        </p>
        <div css={[horizontalStackCss.s, { justifyContent: "space-between" }]}>
          <Button
            data-tname="fundraiserEndAbort"
            role={ButtonRole.TEXT_ONLY}
            size={ButtonSize.MEDIUM}
            disabled={submitting}
            onClick={{
              kind: ButtonTargetKind.FUNCTION,
              action: props.onReject,
            }}
          >
            {props.isActive ? "Keep it running" : "Do not re-activate it"}
          </Button>
          <Button
            data-tname="fundraiserEndConfirm"
            role={ButtonRole.PRIMARY}
            size={ButtonSize.MEDIUM}
            disabled={submitting}
            submitting={submitting}
            onClick={{
              kind: ButtonTargetKind.FUNCTION,
              action: () => {
                onEndFundraiser();
              },
            }}
          >
            {props.isActive ? "End fundraiser" : "Resume fundraiser"}
          </Button>
        </div>
      </div>
    </Modal>
  );
};
